import { HotTable } from '@handsontable/react';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useInput, required } from 'react-admin';

import Handsontable from 'handsontable';

function Trim(x) {
    return x.replace(/^\s+|\s+$/gm,'');
  }
async function checkRange(isnum,value,min,max,callback){

    if(value){
      value=Trim(value);
    }
   
    if (isnum) {
      if (value > min && value < max) {
        callback(true);
      } else {
        callback(false);
      }
  
    } else {
      if (value == '') {
        callback(true);
      } else {
        callback(false);
      }
  
    }
  }
  
function countDuplicates(original, val) {
    if (val === null)
        return 0;
  
      
  
    val = val.toString();
    const uniqueItems = new Set();
    const duplicates = new Set();
    for (const value of original) {
        if (value == val && uniqueItems.has(value)) {
            duplicates.add(value);
            uniqueItems.delete(value);
        } else {
            uniqueItems.add(value);
        }
    }
  
    return duplicates.size;
  }
  
  
  export function uniqueValidatorIdx(value, callback, idx) {
    var vals = window.hot.hotInstance.getDataAtCol(idx);
    var isnum = /^\d+$/.test(value);
    if (isnum) {
        if (value.length > 5) {
  
            if (countDuplicates(vals, value) > 0) {
                callback(false);
            } else {
                callback(true);
            }
        } else {
            callback(false);
        }
  
    } else {
        callback(false);
    }
  
  
  }
  
  export function uniqueValidator7(value, callback) {
    uniqueValidatorIdx(value, callback, 7);
  
  
  }
  export function uniqueValidator8(value, callback) {
    uniqueValidatorIdx(value, callback, 8);
  
  
  }
  export function uniqueValidator9(value, callback) {
    uniqueValidatorIdx(value, callback, 9);
  
  
  }
  export function uniqueValidator10(value, callback) {
    uniqueValidatorIdx(value, callback, 10);
  
  
  }
  export function uniqueValidator11(value, callback) {
    uniqueValidatorIdx(value, callback, 11);
  
  
  }
  export function uniqueValidator12(value, callback) {
    uniqueValidatorIdx(value, callback, 12);
  
  
  }
  export function uniqueValidator1(value, callback) {
    uniqueValidatorIdx(value, callback, 1);
  
  
  }
  export function nidUniqueValidator(value, callback) {
    uniqueValidatorIdx(value, callback, 0);
  
  
  }
  const saudiArabiaLatitudeRange = {
    min: 16.4986,
    max: 32.1610,
  };
  
  const saudiArabiaLongitudeRange = {
    min: 34.5625,
    max: 55.6667,
  };
  
  const saudiNationalIdPattern = /^[1-9]\d{9}$/; // 10-digit Saudi national ID pattern
  

  
  export function validateSaudiNationalId(value, callback) {
  
    callback (
        !isNaN(value) && saudiNationalIdPattern.test(value));
  };
  
  
  
  
  export function validateLatitude(value, callback) {
  
    const latitude = parseFloat(value);
    callback (
        !isNaN(latitude) &&
        latitude >= saudiArabiaLatitudeRange.min &&
        latitude <= saudiArabiaLatitudeRange.max
    );
  };
  
  
  
  
  export function validateLongitude(value, callback) {
  
  
    const longitude = parseFloat(value);
  
    callback (
        !isNaN(longitude) &&
        longitude >= saudiArabiaLongitudeRange.min &&
        longitude <= saudiArabiaLongitudeRange.max
    );
  };

  function capacityValidator(value, callback) {
    var isnum = /^\d+$/.test(value);
    checkRange(isnum,value, 0,81,callback);
  }
  export function uniqueOpcodeValidator(value, callback) {
    var vals = window.hot.hotInstance.getDataAtCol(1);
   
    
      if (value!=null && value.length > 2) {
  
      if (countDuplicates(vals, value) > 0) {
        callback(false);
      } else {
        callback(true);
      }
    }else {
      callback(false);
    }
  
    
  }
  function opValidator(value, callback) {
    var isnum = /^\d+$/.test(value);
    checkRange(isnum,value, 0,10000,callback);
  }

  function monthValidator(value, callback) {
    var isnum = /^\d+$/.test(value);
    checkRange(isnum,value, 0,13,callback);
  }
  
  
  function dayValidator(value, callback) {
    var isnum = /^\d+$/.test(value);
    checkRange(isnum,value, 0,32,callback);
  }
  
  function yearHValidator(value, callback) {
    var isnum = /^\d+$/.test(value);
    checkRange(isnum,value, 1258,1511,callback);
  }
  
   function yearMValidator(value, callback) {
    var isnum = /^\d+$/.test(value);
    checkRange(isnum,value, 1857,2991,callback);
  }
  let   mobileValidatorRegexp = /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/;

  Handsontable.validators.registerValidator('monthValidator', monthValidator);
  Handsontable.validators.registerValidator('dayValidator', dayValidator);
  Handsontable.validators.registerValidator('yearHValidator', yearHValidator);
  Handsontable.validators.registerValidator('yearMValidator', yearMValidator);


  Handsontable.validators.registerValidator('uniqueValidator7', uniqueValidator7);
  Handsontable.validators.registerValidator('validateLongitude', validateLongitude);
  Handsontable.validators.registerValidator('validateLatitude', validateLatitude);
  Handsontable.validators.registerValidator('validateSaudiNationalId', validateSaudiNationalId);
  Handsontable.validators.registerValidator('uniqueValidator8', uniqueValidator8);
  Handsontable.validators.registerValidator('uniqueValidator9', uniqueValidator9);
  Handsontable.validators.registerValidator('uniqueValidator10', uniqueValidator10);
  Handsontable.validators.registerValidator('uniqueValidator11', uniqueValidator11);
  Handsontable.validators.registerValidator('uniqueValidator12', uniqueValidator12);
  Handsontable.validators.registerValidator('uniqueValidator1', uniqueValidator1);
  Handsontable.validators.registerValidator('nidUniqueValidator', nidUniqueValidator);
  Handsontable.validators.registerValidator('validateLatitude', validateLatitude);
  Handsontable.validators.registerValidator('capacityValidator', capacityValidator);
  Handsontable.validators.registerValidator('opValidator', opValidator);
  Handsontable.validators.registerValidator('uniqueOpcodeValidator', uniqueOpcodeValidator);
  Handsontable.validators.registerValidator('mobileValidatorRegexp', mobileValidatorRegexp);

const GridInput = props => {
    const {
        field: { value, onChange },
       fieldState: { isTouched, invalid, error },

      //  meta: { touched, error },
    } = useInput(props);



    const afterValidate = useCallback((isValid, value, row, prop, source) => {
        if (row === window.hot.hotInstance.countRows() - window.hot.hotInstance.getSettings().minSpareRows) {
            return true;
        }
    }, []);

    const handleChange = useCallback((changes, source) => {
        if (source === 'edit' || source === 'CopyPaste.paste') {
            onChange(window.hot.hotInstance.getData());
            window.hot.hotInstance.validateCells(function (valid) {
                // Do something with valid
            });
        }
    }, [onChange]);




 

    const {
        className,
        columns = [],
        colHeaders = [],
        nestedHeaders = [],
        colWidths = [],
        ...rest
    } = props;

    if (error !== undefined && isTouched) {
        setTimeout(() => {
            window.hot.hotInstance.validateCells();
            alert('Please correct errors in the inputs - errors will be highlighted in red.');
        }, 1000);
    }

    const valueDB = value || [];

    return (
      <div style={{ direction: "ltr" }}>
        <HotTable
          ref={(r) => {
            window.hot = r;
          }}
          afterChange={(value, source) => handleChange(value, source)}
          afterValidate={(isValid, value, row, prop, source) =>
            afterValidate(isValid, value, row, prop, source)
          }


          data={valueDB}
          columns={columns}
          colHeaders={colHeaders}
          nestedHeaders={nestedHeaders}
          minSpareRows="1"
          width="100%"
          direction="ltr"
          invalidCellClassName="htInvalid"
          overflow="hidden"
          autoWrapRow={true}
          rowHeaders={true}
          licenseKey="34af8-b0470-3cdb0-14611-d084b"
          contextMenu={{
            items: {
              remove_row: {
                name: "حذف السجلات", // Custom label for removing row
              },

              sep1: "---------", // Separator (optional)
              undo: {
                name: "تراجع",  // Localized label for Undo
              },
              redo: {
                name: "إعادة",  // Localized label for Redo
              },
            },
          }}
          height="300"
        />
      </div>
    );
};

GridInput.propTypes = {
    field: PropTypes.object,
   // meta: PropTypes.object,
    className: PropTypes.string,
    columns: PropTypes.array,
    colHeaders: PropTypes.array,
    nestedHeaders: PropTypes.array,
    colWidths: PropTypes.array,
};

export default GridInput;
